import { computed, ComputedRef, ref, type Ref, watchEffect } from "vue";

export const baseStarsAngles: number[] = [0, 45, 90, 135, 180, 225, 270, 315];

export interface ContainerProperties {
  centerX: number;
  centerY: number;
  radius: number;
}

export function useStarsPositions(
  offsetAngle: Ref<number> | ComputedRef<number>,
  getContainerProperties: () => ContainerProperties | null
) {
  const getStarIndex = (index: number) => (index === 0 ? 8 : index);

  const starsContainerProperties = ref<ContainerProperties>({
    centerX: 0,
    centerY: 0,
    radius: 0,
  });
  const centerAngle = ref(0);

  watchEffect(() => {
    const props = getContainerProperties();
    if (props) {
      starsContainerProperties.value = props;
    }
  });

  const starsPositions = computed(() => {
    const { centerX, centerY, radius } = starsContainerProperties.value;

    return baseStarsAngles.map((baseAngle) => {
      const angleDeg = (baseAngle + offsetAngle.value) % 360;
      const angleRad = (angleDeg + centerAngle.value) * (Math.PI / 180);

      const x = centerX + radius * Math.cos(angleRad);
      const y = centerY + radius * Math.sin(angleRad);

      return { x, y, angleDeg };
    });
  });

  return {
    starsPositions,
    starsContainerProperties,
    centerAngle,
    getStarIndex,
  };
}
